import { gsap } from 'gsap/all'

const downArrow = {
  el: {
    downArrow: document.querySelector<HTMLElement>('.down-arrow'),
    greenShapeContainer: document.querySelector<HTMLElement>('.shape-container'),
  },

  init(): void {
    if (this.el.downArrow && this.el.greenShapeContainer) {
      this.el.downArrow.addEventListener('click', () => {
        gsap.to(window, {
          duration: 1,
          ease: 'power2.inOut',
          scrollTo: this.el.greenShapeContainer,
        })
      })
    }
  },
}

export default downArrow
